import { Flex, Link, useCurrentMode } from '@lokalise/louis';

import useSelector from '@app/hooks/useSelector';
import { getTeam } from '@app/selectors';
import { showNewMessage } from '@app/utils/intercom';

import NoSeatsLeftLight from './assets/No_seats_left.png';
import NoSeatsLeftDark from './assets/darkmode/No_seats_left.png';

const NoSeatsLeft = ({ teamName }: { teamName: string }) => {
    const isDarkModeEnabled = useCurrentMode() === 'dark';
    const { role } = useSelector(getTeam);

    const renderRoleBasedContent = () => {
        if (role === 'biller' || role === 'owner') {
            return (
                <p>
                    No worries, you can easily <Link href="/team#billing">buy more seats</Link>.
                </p>
            );
        }

        if (role === 'admin') {
            return (
                <p>
                    Get in touch with <Link href="/team">billers</Link> for adding seats.
                </p>
            );
        }

        return (
            <>
                <p>
                    Contact <strong>{teamName}</strong> billers for adding seats.
                </p>
                <p>
                    <Link onClick={() => showNewMessage()}>Get in touch</Link> with Lokalise support if you have any
                    questions.
                </p>
            </>
        );
    };

    return (
        <Flex direction="column" align="center" gap={3}>
            <img src={isDarkModeEnabled ? NoSeatsLeftDark : NoSeatsLeftLight} alt="No seats left" height={150} />
            <h1>No seats left</h1>
            {renderRoleBasedContent()}
        </Flex>
    );
};

export default NoSeatsLeft;
